export default __webpack_public_path__ + "static/media/2412310.e5ae4645.jpg";